import { render, staticRenderFns } from "./community.vue?vue&type=template&id=a669db9c&scoped=true"
import script from "./community.vue?vue&type=script&lang=ts"
export * from "./community.vue?vue&type=script&lang=ts"
import style0 from "./community.vue?vue&type=style&index=0&id=a669db9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a669db9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeading: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-heading.vue').default,BtnMore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-more.vue').default})
